import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  syncDeviceLoading: {},
};

const syncLoadingSlice = createSlice({
  name: "syncLoading",
  initialState,
  reducers: {
    setSyncDeviceLoading: (state, action) => {
      state.syncDeviceLoading = action.payload;
    },
    updateSyncDeviceLoading: (state, action) => {
      const { deviceId, isLoading } = action.payload;
      state.syncDeviceLoading[deviceId] = isLoading;
    },
    resetSyncDeviceLoading: (state) => {
      state.syncDeviceLoading = {};
    },
  },
});

export const {
  setSyncDeviceLoading,
  updateSyncDeviceLoading,
  resetSyncDeviceLoading,
} = syncLoadingSlice.actions;

export default syncLoadingSlice.reducer;
